import CheckoutPaperView from './CheckoutPaperView';

export default function CheckoutPaper({ title, children }) {
    return <CheckoutPaperView {...{ title, children }} />;
}
